import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const FormSuccessPopup = ({ isOpen, onClose, type = 'success', message, isSyllabusForm = false }) => {
  useEffect(() => {
    // Only manage overflow if body is not already locked by mobile menu
    const isBodyLocked = document.body.style.position === 'fixed';
    
    if (isOpen) {
      if (!isBodyLocked) {
        document.body.style.overflow = 'hidden';
      }
      
      // Auto-close popup after 2 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 2000);
      
      return () => {
        clearTimeout(timer);
        const isBodyLocked = document.body.style.position === 'fixed';
        if (!isBodyLocked) {
          document.body.style.removeProperty('overflow');
        }
      };
    } else {
      if (!isBodyLocked) {
        document.body.style.removeProperty('overflow');
      }
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const displayMessage = message;

  const popupContent = (
    <>
      <style>{`
        @keyframes successPopIn {
          0% {
            opacity: 0;
            transform: perspective(1000px) rotateX(-15deg) scale(0.8);
          }
          100% {
            opacity: 1;
            transform: perspective(1000px) rotateX(0deg) scale(1);
          }
        }

        @keyframes checkmarkBounce {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.15);
          }
        }

        @keyframes drawCheck {
          0% {
            stroke-dasharray: 0, 100;
          }
          100% {
            stroke-dasharray: 100, 0;
          }
        }

        .popup-overlay {
          animation: fadeIn 0.3s ease;
        }

        .popup-content {
          animation: successPopIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .popup-icon {
          animation: checkmarkBounce 0.5s ease-out 0.15s;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>

      <div 
        className="popup-overlay"
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(8px)',
          zIndex: 999999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          margin: 0,
          padding: 0
        }}
      >
        <div 
          className="popup-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            background: type === 'success'
              ? 'linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(240, 255, 240, 0.95))'
              : 'linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 240, 240, 0.95))',
            backdropFilter: 'blur(20px)',
            padding: '2rem 1.5rem 1.5rem',
            borderRadius: '15px',
            maxWidth: '320px',
            position: 'relative',
            width: '85%',
            boxShadow: type === 'success'
              ? '0 20px 40px rgba(0, 0, 0, 0.25), 0 1px 2px rgba(255, 255, 255, 0.8) inset, 0 8px 20px rgba(34, 197, 94, 0.15)'
              : '0 20px 40px rgba(0, 0, 0, 0.25), 0 1px 2px rgba(255, 255, 255, 0.8) inset, 0 8px 20px rgba(239, 68, 68, 0.15)',
            border: type === 'success'
              ? '2px solid rgba(34, 197, 94, 0.3)'
              : '2px solid rgba(239, 68, 68, 0.3)',
            textAlign: 'center',
            transform: 'perspective(1000px) rotateX(0deg)'
          }}
        >
          {/* Icon */}
          <div 
            className="popup-icon"
            style={{
              width: '60px',
              height: '60px',
              margin: '0 auto 1rem',
              background: type === 'success'
                ? 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)'
                : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: type === 'success'
                ? '0 6px 15px rgba(34, 197, 94, 0.35), 0 1px 2px rgba(255, 255, 255, 0.3) inset'
                : '0 6px 15px rgba(239, 68, 68, 0.35), 0 1px 2px rgba(255, 255, 255, 0.3) inset'
            }}
          >
            {type === 'success' ? (
              <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" style={{ animation: 'drawCheck 0.4s ease-out 0.3s both' }} />
              </svg>
            ) : (
              <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            )}
          </div>

          {/* Title */}
          <h3 style={{
            color: '#00315d',
            fontSize: '1.4rem',
            fontWeight: '700',
            marginBottom: '0.5rem',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
          }}>
            {type === 'success' ? 'Success!' : 'Failed!'}
          </h3>

          {/* Message */}
          <p style={{
            color: type === 'success' ? '#16a34a' : '#dc2626',
            fontSize: '0.95rem',
            marginBottom: '1.2rem',
            fontWeight: '600'
          }}>
            {type === 'success' ? 'Form submitted successfully' : 'Submission failed'}
          </p>


        </div>
      </div>
    </>
  );

  return ReactDOM.createPortal(popupContent, document.body);
};

export default FormSuccessPopup;
